import React, { createContext, useState } from "react";
import App from "../App";

export const appContext = createContext<any>({});

export const AppContext = () => {
  const [loggedIn, setLoggedIn] = useState<boolean>(true);
  const [chatId, setChatId] = useState<any>(null);
  return (
    <appContext.Provider
      value={{
        loggedIn,
        chatId,
        setChatId,
        setLoggedIn,
      }}
    >
      <App />
    </appContext.Provider>
  );
};
